import { Snippet } from '../../types'

export default {
  label: 'basic',
  code: 'local message:string = "hello world!"'
} as Snippet
